import React from 'react';
import { Link } from 'react-router-dom';
import { Camera, Layers, ArrowRight } from 'lucide-react';
import { BeforeAfterSlider } from '../BeforeAfterSlider';

export function ProviderPortfolio({ portfolio, transformations }) {
  const hasPortfolio = portfolio && portfolio.length > 0;
  const hasTransformations = transformations && transformations.length > 0;

  if (!hasPortfolio && !hasTransformations) return null;

  return (
    <>
      {/* Portfolio Gallery */}
      <div className="mb-8" data-testid="provider-portfolio-section">
        <h2 className="font-heading text-xl font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
          <Camera className="h-5 w-5 text-[#D4AF37]" />
          Our Work
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="provider-portfolio-grid">
          {(portfolio || []).map((img) => (
            <div key={img.image_id} className="group relative rounded-lg overflow-hidden bg-stone-100 aspect-square">
              <img
                src={img.url}
                alt={img.caption || 'Portfolio'}
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
                loading="lazy"
              />
              {img.caption && (
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <p className="text-white text-sm font-medium truncate">{img.caption}</p>
                  {img.category && (
                    <span className="text-xs text-white/70 capitalize">{img.category}</span>
                  )}
                </div>
              )}
            </div>
          ))}
          {(transformations || []).map((t) => (
            <div key={t.transformation_id} className="group relative rounded-lg overflow-hidden bg-stone-100 aspect-square" data-testid={`portfolio-tf-${t.transformation_id}`}>
              <img
                src={t.after_image}
                alt={t.caption || 'Transformation'}
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
                loading="lazy"
              />
              <span className="absolute top-2 left-2 bg-[#D4AF37] text-white text-xs px-2 py-0.5 rounded flex items-center gap-1">
                <Layers className="h-3 w-3" />
                Before & After
              </span>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                {t.caption && <p className="text-white text-sm font-medium truncate">{t.caption}</p>}
                {t.service_name && (
                  <span className="text-xs text-[#D4AF37]">{t.service_name}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dedicated Transformations Section with Sliders */}
      {hasTransformations && (
        <div className="mb-8" data-testid="provider-transformations-section">
          <h2 className="font-heading text-xl font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
            <Layers className="h-5 w-5 text-[#D4AF37]" />
            Transformations
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {transformations.map((t) => (
              <div key={t.transformation_id} className="card-surface overflow-hidden" data-testid={`transformation-card-${t.transformation_id}`}>
                <BeforeAfterSlider
                  beforeSrc={t.before_image}
                  afterSrc={t.after_image}
                  alt={t.caption || 'Transformation'}
                />
                <div className="p-4">
                  {t.caption && <p className="font-medium text-[#1A1A1A] mb-1">{t.caption}</p>}
                  {t.service_id && t.service_name && (
                    <Link
                      to={`/service/${t.service_id}`}
                      className="inline-flex items-center gap-1.5 text-sm font-medium text-[#D4AF37] hover:underline mt-1"
                      data-testid={`tf-book-${t.transformation_id}`}
                    >
                      Book {t.service_name}
                      <ArrowRight className="h-3.5 w-3.5" />
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
